import * as R from 'ramda';

export default function ActiveAuditController(
  $filter,
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  editAuditDialog,
  loaderService,
  markAuditCompleteConfirmDialog,
  orgDataService,
  ssDialogService,
  reportsDataService,
) {
  const vm = this;
  
  vm.groupId = 16;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.isGeneralInformationExpanded = false;

  vm.handleExpandAudit = handleExpandAudit;
  vm.handleExpandGeneralInformation = handleExpandGeneralInformation;

  vm.handleEdit = handleEdit;
  vm.handleDelete = handleDelete;
  vm.handleMarkStatusComplete = handleMarkStatusComplete;
  vm.handleRunDetailReport = _handleRunDetailReport;
  vm.handleConfirmDelete = handleConfirmDelete;
  vm.handleCancelDelete = closeDeleteDialog;

  _initEventListeners();

  /** *********************************************
   * Event Handlers
   */

  function handleExpandAudit() {
    vm.isExpanded = !vm.isExpanded;
  }

  function handleExpandGeneralInformation() {
    vm.isGeneralInformationExpanded = !vm.isGeneralInformationExpanded;
  }

  function handleEdit($event) {
    loaderService.showViewLoader = true;
    return _refreshAgencies().then(() =>
      _refreshUsers().then(() =>
        amDataService.getDataTypes().then(getDataTypesResponse =>
          amDataService.getAudit(vm.audit.auditId).then(getAuditResponse => {
            loaderService.showViewLoader = false;
            return _showEditAuditDialog($event, {
              audit: getAuditResponse.data,
              agencies: amSharedModelService.agencies,
              auditTypes: amSharedModelService.auditTypes,
              coordinators: amSharedModelService.coordinators,
              dataTypes: getDataTypesResponse.data.result,
              refreshAudit: true,
            });
          }),
        ),
      ),
    );
  }

  function _refreshAgencies() {
    return amDataService.getAgencies().then(response => {
      vm.agencies = response.data.result;

      let found = false;
      R.forEach(agency => {
        if (agency.agencyId === vm.audit.agencyId) {
          found = true;
        }
      }, vm.agencies);

      if (!found && vm.audit.agency !== null) {
        vm.agencies.push(vm.audit.agency);
      }

      vm.agencies = R.sortBy(R.prop('name'), vm.agencies);

      amSharedModelService.agencies = vm.agencies;
    });
  }

  function _refreshUsers() {
    return orgDataService.getApplicationUsers().then(appUserResponse => {
      vm.coordinators = appUserResponse.data.result;
      amSharedModelService.coordinators = vm.coordinators;

      orgDataService.getSelectableUsers().then(assignableUserResponse => {
        vm.applicationUsers = assignableUserResponse.data.result;
        amSharedModelService.applicationUsers = vm.applicationUsers;
      });
    });
  }

  function handleMarkStatusComplete($event) {
    loaderService.showViewLoader = true;
    return _showMarkAuditCompleteConfirmDialog($event, {
      audit: vm.audit,
      refreshAudit: false,
      returnScreen: 'main',
      canSave: false,
    });
  }

  function _handleRunDetailReport() {
    loaderService.showViewLoader = true;
    return amDataService.getAuditTrailDetailReport().then(reportData => {
      const reportId = reportData.data.reportId;
      const parameters = [];
      parameters.push({
        parameterName: 'AuditID',
        parameterValue: vm.audit.auditId.toString(),
      });
      parameters.push({
        parameterName: 'ItemTypeID',
        parameterValue: '-1',
      });
      parameters.push({
        parameterName: 'CompletedAfter',
        parameterValue: null,
      });
      reportsDataService.viewAppReportByGroup(vm.groupId, reportId, 'PDF', parameters, false).then(response => {
        reportsDataService.download(response);
        loaderService.showViewLoader = false;
      });
    });
  }

  function handleDelete($event) {
    return _showDeleteDialog($event, {
      dialogTitle: 'Delete Active Audit Exam?',
      message: `Are you sure you want to delete audit/exam "${vm.audit.name}"?`,
      handleYesClick: handleConfirmDelete,
      handleNoClick: closeDeleteDialog,
    });
  }

  function handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService
      .deleteAudit(vm.audit.auditId)
      .then(() => {
        alerts.success('The audit has been deleted successfully.');
        $rootScope.$broadcast('refreshAMAudits');
        return closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting audit.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteActiveAuditConfirmDialog);
  }

  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('refreshAMAudit', (event, opt) => {
      if (opt.auditId === vm.audit.auditId) {
        amDataService.getAudit(opt.auditId).then(getAuditResponse => {
          vm.audit = getAuditResponse.data.result;
        });
      }
    });
  }

  function _showDeleteDialog($event, locals) {
    ssDialogService.dialogs.auditTrail.deleteActiveAuditConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteActiveAuditConfirmDialog);
  }

  function _showEditAuditDialog($event, locals) {
    ssDialogService.dialogs.auditTrail.editAuditDialog = ssDialogService.alert(
      editAuditDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.editAuditDialog);
  }

  function _showMarkAuditCompleteConfirmDialog($event, locals) {
    ssDialogService.dialogs.auditTrail.markAuditCompleteConfirmDialog = ssDialogService.alert(
      markAuditCompleteConfirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.markAuditCompleteConfirmDialog);
  }
}

ActiveAuditController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'editAuditDialog',
  'loaderService',
  'markAuditCompleteConfirmDialog',
  'orgDataService',
  'ssDialogService',
  'reportsDataService',
];
